import React from "react";
import { FaMoneyBillTrendUp, FaMoneyBillTransfer } from "react-icons/fa6";

const TransactionSummary = ({ summary }) => {
  return (
    <div className="main-cards">
      <div className="card">
        <div className="card-inner">
          <h3 className="text-light">Total Credit</h3>
          <FaMoneyBillTrendUp className="card_icon text-light" />
        </div>
        <h1>₹{summary.totalCredit}</h1>
      </div>

      <div className="card">
        <div className="card-inner">
          <h3 className="text-light">Total Debit</h3>
          <FaMoneyBillTransfer className="card_icon text-light" />
        </div>
        <h1>₹{summary.totalDebit}</h1>
      </div>
    </div>
  );
};

export default TransactionSummary;
